import { ApolloLink } from "./ApolloLink.js";
export var concat = ApolloLink.concat;